<script setup>
import { computed } from "vue";
import { useShopifyStore } from "@stores/shopify.js";
import Instagram from "@components/icons/Instagram.vue";

const shopify = useShopifyStore();

const posts = computed(() => shopify.instagramPosts);
</script>

<template>
	<section v-if="posts.length > 0" class="py-48 lg:py-80">
		<div class="container">
			<div
				class="mb-24 flex flex-wrap items-center justify-between gap-16 lg:mb-48"
			>
				<h2 class="h3 font-primary-condensed">Join our instagram</h2>
				<a
					href="https://www.instagram.com/ghostvisn/"
					target="_blank"
					rel="noopener noreferrer"
					class="flex items-center gap-8"
				>
					<span class="h5 font-primary-condensed">@ghostvisn</span>
					<Instagram />
				</a>
			</div>
			<div class="grid grid-cols-2 gap-8 lg:grid-cols-6">
				<div v-for="(post, index) in posts" :key="index">
					<a
						v-if="post.url"
						:href="post.url"
						target="_blank"
						rel="noopener noreferrer"
						class="block overflow-hidden rounded-lg"
					>
						<img
							v-if="post.image"
							:src="post.image"
							:alt="post.image_alt || 'Instagram post'"
							class="aspect-square w-full object-cover transition-transform duration-300 hover:scale-105"
						/>
					</a>
					<div v-else class="overflow-hidden rounded-lg">
						<img
							v-if="post.image"
							:src="post.image"
							:alt="post.image_alt || 'Instagram post'"
							class="aspect-square w-full object-cover"
						/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
